import Text from 'src/components/Text';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { PRIMARY_BLACK } from 'src/global/theme/colors';

interface Props {
  logDetail: string;
}

const TransactionLogDetail = ({ logDetail }: Props) => {
  return (
    <Accordion elevation={0}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-content" id="panel-header">
        <Text variant="H3-Medium" color={PRIMARY_BLACK}>
          Información Adicional
        </Text>
      </AccordionSummary>
      <AccordionDetails>
        <Text variant="Caption-Regular" style={{ padding: '5px' }}>
          <pre>{JSON.stringify(logDetail, null, 4)}</pre>
        </Text>
      </AccordionDetails>
    </Accordion>
  );
};

export default TransactionLogDetail;
